import { makeStyles } from '@material-ui/core';
import { theme } from '../../../../../../../theme';

// Template surface tint #f7faff is not yet in theme.palette.colors.
const TEMPLATE_SURFACE = '#f7faff';

export const templateAutocompleteSx = {
  width: '100%',
  margin: 0,
  '& .MuiFormControl-root': {
    margin: 0,
  },
  '& .MuiOutlinedInput-root': {
    width: '100%',
    height: '40px',
    minHeight: '40px',
    borderRadius: '50px',
    paddingLeft: '16px',
    paddingRight: '40px',
    boxSizing: 'border-box',
    backgroundColor: theme.textWhite.main,
    alignItems: 'center',
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.greyScale.slateGray,
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.greyScale.slateGray,
      boxShadow: 'none',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.colors.bluePrimaryMain,
      borderWidth: '1px',
      boxShadow: 'none',
    },
  },
  '& .MuiOutlinedInput-root .MuiAutocomplete-input': {
    padding: '0 !important',
    height: '24px',
    boxSizing: 'border-box',
    fontFamily: 'Inter, sans-serif',
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '24px',
    letterSpacing: '0.32px',
    color: theme.palette.colors.grey110,
  },
  '& .MuiInputLabel-root': {
    color: `${theme.palette.primary.deep} !important`,
    fontFamily: 'Inter, sans-serif !important',
    fontSize: '14px !important',
    fontWeight: '700 !important',
    lineHeight: '22px !important',
    letterSpacing: '0.28px !important',
    transform: 'translate(14px, -9px) scale(0.75) !important',
    backgroundColor: theme.textWhite.main,
    padding: '0 6px',
    '&.Mui-focused': {
      color: `${theme.palette.primary.deep} !important`,
    },
  },
  '& .MuiAutocomplete-endAdornment': {
    right: '12px',
    top: '50%',
    transform: 'translateY(-50%)',
  },
};

export const useTemplateDropdownStyles = makeStyles((muiTheme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    width: '100%',
    position: 'relative',
    marginTop: '20px',
  },
  pointer: {
    width: 0,
    height: 0,
    marginLeft: '46px',
    marginBottom: '-1px',
    borderLeft: '10px solid transparent',
    borderRight: '10px solid transparent',
    borderBottom: `10px solid ${muiTheme.palette.colors.bluePrimaryMain}`,
    position: 'relative',
    zIndex: 2,
    '&::after': {
      content: '""',
      position: 'absolute',
      left: '-9px',
      top: '2px',
      borderLeft: '9px solid transparent',
      borderRight: '9px solid transparent',
      borderBottom: `9px solid ${TEMPLATE_SURFACE}`,
    },
  },
  field: {
    width: '100%',
    padding: '16px',
    boxSizing: 'border-box',
    borderRadius: '16px',
    backgroundColor: TEMPLATE_SURFACE,
    border: `1px solid ${muiTheme.palette.colors.bluePrimaryMain}`,
    overflow: 'visible',
  },
  autocompleteRoot: {
    width: '100%',
  },
  paper: {
    padding: '0 !important',
    '& .MuiAutocomplete-listbox': {
      padding: '0 !important',
      margin: 0,
    },
    '& .MuiAutocomplete-listbox .MuiAutocomplete-option': {
      width: '100% !important',
      margin: '0 !important',
      padding: '0 !important',
      boxSizing: 'border-box',
      minHeight: '0 !important',
    },
  },
  listbox: {
    padding: '0 !important',
    margin: 0,
  },
  optionContent: {
    display: 'block',
    width: '100%',
    boxSizing: 'border-box',
    padding: '5px 16px',
  },
}));
